import React from 'react';
import { Drawer, Button } from 'antd';
import { useConfigurationDrawer } from '../context';
import { ModalChatbot } from './ModalChatbot';
import { IWindowCartItem } from '../types';

interface ConfigurationEditDrawerProps {
    onSave: (updatedItem: IWindowCartItem) => void | Promise<void>;
    isSaving?: boolean;
}

/**
 * Configuration Edit Drawer
 *
 * A drawer component that allows editing of window configurations
 * Uses ConfigurationDrawerContext for state management
 */
export const ConfigurationEditDrawer: React.FC<ConfigurationEditDrawerProps> = ({ onSave, isSaving = false }) => {
    const { state, method } = useConfigurationDrawer();
    return (
        <Drawer
            title={
                state.editingQuestionId
                    ? "Edit Configuration"
                    : "Configuration"
            }
            placement="right"
            width={600}
            open={state.isOpen}
            onClose={() => {
                method.discardChanges();
            }}
            footer={
                <div className="flex gap-2 justify-end">

                    <div className="flex gap-2">
                        <Button size="large" onClick={method.discardChanges}>
                            Cancel
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            disabled={!state.isEditingComplete || state.isBlending || isSaving}
                            loading={state.isBlending || isSaving}
                            onClick={async () => {
                                await method.saveChanges(onSave);
                            }}
                        >
                            Update Configuration
                        </Button>
                    </div>
                </div>
            }
            styles={{
                body: {
                    padding: 0,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                }
            }}
        >
            <ModalChatbot />
        </Drawer>
    );
};
